export default __webpack_public_path__ + "static/media/228.1450d468.png";